import React from 'react'

// Hooks
import { useGlobal } from '../../../../../hooks'

import { AdministrationList } from '../../../List'

// Queries
import { DELETE_ANOMALY_TYPES, LIST_ANOMALY_TYPES } from './queries'

const table = [
  { th: 'ID', td: 'id' },
  { th: 'Descripción', td: 'name' },
]

const queries = { list: LIST_ANOMALY_TYPES, delete: DELETE_ANOMALY_TYPES }

const AdministrationListAnalysisAnomalyTypes = () => {
  const [{ me }] = useGlobal()

  const no = ![1, 2].includes(me.id_role)

  return (
    <AdministrationList
      table={table}
      queries={queries}
      noCreate={no}
      noUpdate={no}
      noDelete={no}
    />
  )
}

export default AdministrationListAnalysisAnomalyTypes
